<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop>
                   <div class="modal-content  p-2">

                        <div class="modal-header">
                             <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                                    <span aria-hidden="true">×</span>
                                </button>          
                        </div>                
                        
                        <div class="modal-body" style="padding-top: 15px !important;">
                          <div class="row">
                            <div class="col-7">
                              <div class="maheading_2">
                                <h5 class="modal-title">Payment Method</h5>
                              </div>  
                            </div>
                            <div class="col-5 text-right">
                              <button type="submit" class="btn btn-md ma-blue-btn" @click="openNewPaymentMethodModal()">New Payment Method</button>
                            </div>
                          </div>


                          <div class="row heading">
                            <div class="col-1" style="text-decoration: none !important;">
                              
                            </div>
                            <div class="col-3">
                              Name
                            </div>
                            <div class="col-4">
                              Method
                            </div>
                            <div class="col-2">
                              Exp
                            </div>
                            <div class="col-2 text-center">
                              Remove
                            </div>

                          </div>

                      <div class="pt-2" v-if="loading == true">
                        <div class="row" v-for="option in 5">
                          <div class="col-1 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="col-3 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="col-4 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="col-2 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="col-2 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="col-12 p-0">
                            <div class="custom_hr"></div>
                          </div>
                        </div>
                      </div>

                          <div class="row view" v-for="(list, index) in paymentMethods" :key="index" v-if="loading == false">
                            <div class="col-1 text-center" style="margin-top: 3px !important">
                    <div class="custom-control custom-radio custom-control-inline" style="margin-right: 0px !important;">
                              <input
                                  type="radio"
                                  v-bind:id="'is_p_primary_' + index"
                                  ref="'is_p_primary_' + index"
                                  v-bind:name="'is_p_primary[' + index + ']'"
                                  v-model="list.isPrimary"
                                  @click="clickPrimary(index)"
                                  :value="1" style="margin-top: 0px !important;" class="custom-control-input" >
                    <label 
                      class="custom-control-label" 
                      :for="'is_p_primary_' + index" style="margin-top: -2px !important; margin-left: 20px !important;"></label>
                  </div>

                            </div>
                            <div class="col-3">
                              {{ list.cardName }}
                            </div>
                            <div class="col-4">
                              {{ list.cardNo }}
                            </div>
                            <div class="col-2">
                              {{ list.exp }}
                            </div>
                            <div class="col-2 text-center" v-if="list.isPrimary == 1">
                              <span class="badge badge-info text-uppercase" style="background-color: #4088bd;">Primary</span>

                            </div>
                            <div class="col-2 text-center" v-else>
                              <i class="fa fa-close cursor-pointe remove-icon" aria-hidden="true" @click="deletePayment(index)"></i>
                            </div>

                          </div>

                          <div class="text-center m-4">
                              <button :disabled="process_payment_disable" type="button" class="btn btn-md ma-blue-btn" @click="onSubmit">
                                  Save
                              </button>
                          </div>


                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>

        <NewPaymentMethod
          :isModalVisible="isNewPaymentMethodModalVisible"
          ref="NewPaymentMethodModal"
          @close="isNewPaymentMethodModalVisible = false">
        </NewPaymentMethod>

        <DeleteModal :isModalVisible="isDeleteModalVisible" @close="isDeleteModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; deleteAdminAction(delete_id)">Confirm</button>
          </div>
        </DeleteModal>



    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import { BPopover } from 'bootstrap-vue'
Vue.component('b-popover', BPopover)


import NewPaymentMethod from './new_payment_method.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';

Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible'],
    data() {
        return {
            loading: false,
            subscriptions: [],
            paymentMethods:  [],
            isNewPaymentMethodModalVisible: false,
            process_payment_disable: false,
            isDeleteModalVisible: false,
        }
    },
    components: {
      NewPaymentMethod,
      DeleteModal,
    },
    methods: {       
        hide() { 
            this.$emit('close');
        },
        deletePayment(index) {
          this.isDeleteModalVisible = true;
          this.delete_id = this.paymentMethods[index].id;
        },
        deleteAdminAction(id) {
          axios('/new-payment-method-primary-update', 
          {
              method: 'POST',
              data: {
                "account_id": this.$store.state.user_accountid,
                "paymentMethods": this.paymentMethods,
              }
          })
          .then((response) => {
              this.process_payment_disable = false;
              axios('/new-payment-method', 
              {
                  method: 'DELETE',
                  data: {
                    "id": id,
                  },

              })
              .then((response) => {
                  this.process_payment_disable = false;
                  this.loadInitialData();
              })
              .catch(error => {
                  this.process_payment_disable = false;
                  console.log(error)
              });
          })
          .catch(error => {
              this.process_payment_disable = false;
              console.log(error)
          });

        },
        openNewPaymentMethodModal() {
          this.isNewPaymentMethodModalVisible = true;
          this.$refs.NewPaymentMethodModal.loadInitialData();
        },
        closePaymentMethod() {
          this.isNewPaymentMethodModalVisible = false;
          this.loadInitialData();
        },
        onSubmit() {
          this.process_payment_disable = true;
          axios('/new-payment-method-primary-update', 
          {
              method: 'POST',
              data: {
                "account_id": this.$store.state.user_accountid,
                "paymentMethods": this.paymentMethods,
              }
          })
          .then((response) => {
              this.process_payment_disable = false;
              this.$parent.closePaymentMethodLists();
          })
          .catch(error => {
              this.process_payment_disable = false;
              console.log(error)
          });
        },
        clickPrimary: function(index) {
          for(var i=0; i < this.paymentMethods.length; i++) {
            this.paymentMethods[i].isPrimary = 0;
          }
          this.paymentMethods[index].isPrimary = 1;
        },
        loadInitialData() {
          this.loading = true;
          axios('/desktop/get-payment-method-lists/'+ this.$store.state.user_accountid,
          {
            method: 'GET'        
          })
          .then(resp => {     
            this.loading = false;   
            this.paymentMethods = resp.data.paymentMethods;

          })
          .catch(() => {
          });      

        },
    },
    created() {

    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.rounded {
    border-radius: 10px !important;
    padding: 20px;
    border: 1px solid #B8B7B8;
}
.seat_qty {
    font-size: 13px;
}
.heading {
  font-weight: normal;
  text-decoration: underline;
  margin-bottom: 10px;
  margin-top: 20px;
}
.remove-icon {
  color: #FF0000;
  font-size: 21px;
  cursor: pointer;
  font-weight: normal;
}
</style>




// WEBPACK FOOTER //
// src/components/manager/payment_method_lists.vue